export default "__VITE_ASSET__a77158cb__"